export enum TimePeriod {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  YEARLY = 'Annually',
  ALL = 'All',
}

export enum UserStatus {
  ACTIVE = 'Active',
  BLOCK = 'Block',
}

export enum TabKeys {
  PROFILE = 'profile',
  CHANGE_PASSWORD = 'change-password',
  HELP = 'help',
  PRIVACY_POLICY = 'privacy-policy',
  BROADCAST_NOTIFICATION = 'broadcast-notification',
  LOCATION_TEXT = 'location-text',
  ESIGN_AGREEMENT = 'esign-agreement',
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
}

export const TabLabels = {
  [TabKeys.PROFILE]: 'Profile',
  [TabKeys.CHANGE_PASSWORD]: 'Change Password',
  [TabKeys.HELP]: 'Help',
  [TabKeys.PRIVACY_POLICY]: 'Manage Privacy Policy',
  [TabKeys.BROADCAST_NOTIFICATION]: 'Broadcast Notification',
  [TabKeys.LOCATION_TEXT]: 'Manage Location Text',
  [TabKeys.ESIGN_AGREEMENT]: 'Manage Esign Agreement',
  [TabKeys.TERMS_AND_CONDITIONS]: 'terms and conditions',
}
